var DataLayer = /** @class */ (function () {
    function DataLayer(options) {
        this.cookies = {};
        var cookieFactory = options.cookieFactory;
        Object.assign(this, options, this.getCookieFactoryLabels(cookieFactory));
    }
    DataLayer.prototype.setCookieFactory = function (name) {
        this.cookies[name] = this.cookieFactory(name);
    };
    DataLayer.prototype.getCookieFactoryLabels = function (cookieFactory) {
        var _this = this;
        if (!cookieFactory)
            return {};
        return {
            getCookie: function (_a) {
                var name = _a.name;
                if (!_this.cookies[name])
                    _this.setCookieFactory(name);
                return _this.cookies[name].getValue();
            },
            removeCookie: function (_a) {
                var name = _a.key, options = _a.options;
                if (!_this.cookies[name])
                    return;
                _this.cookies[name].removeValue({ options: options });
            },
            setCookie: function (_a) {
                var name = _a.name, value = _a.value, options = _a.options;
                if (!_this.cookies[name])
                    _this.setCookieFactory(name);
                _this.cookies[name].setValue({ name: name, value: value, options: options });
            },
        };
    };
    return DataLayer;
}());
export { DataLayer };
var mountDataLayer = function (options) { return new DataLayer(options); };
export default mountDataLayer;
